import { Provider } from "@angular/core";
import { ENVIRONMENT } from "@hiptraveler/common";

import { environment } from "@hiptraveler/environments";

export const EnvironmentProvider: Provider = {
  provide: ENVIRONMENT,
  useValue: environment
}
